import { useAbility as useAbilityCasl } from '@casl/react'

import { AbilityContext } from '.'

export const useAbility = () => useAbilityCasl(AbilityContext)
